



















import VueOptions from '@utils/VueOptions'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

settings =
  name: 'TreeSelector'
  vue:
    props: ['list', 'initialValue', 'actions', 'options']
    components: { Treeselect }

    data: ->
      value: null

    computed:
      placeholder: -> @options?.placeholder || 'Select'
      disabled: -> @options?.disabled || false
      multiple: -> @options?.multiple || true
      clearOnSelect: -> @options?.clearOnSelect || true
      closeOnSelect: -> @options?.closeOnSelect || true
      openOnMount: -> @options?.openOnMount || false
      flat: -> @options?.flat || true
      autoSelectAncestors: -> @options?.autoSelectAncestors || true
      sortValueBy: -> @options?.sortValueBy || 'LEVEL'
      disableFuzzyMatching: -> @options?.disableFuzzyMatching || true

    mounted: ->
      @$refs.treeSelect.openMenu() if @openOnMount

    methods:
      hiSelect: (item) ->
        @$refs.treeSelect.closeMenu() if @closeOnSelect
        setTimeout(() =>
          @actions.select item.id.split('.')
        , 0)

      hiDeselect: (item) ->
        setTimeout(() =>
          ancestors = item.id.split('.').slice(0, -1) || []
          @actions.select ancestors
        , 0)

    watch:
      initialValue: (value) ->
        ids = []
        parent = ''
        for id in value
          parent = if parent then "#{parent}.#{id}" else id
          ids.push parent
        @value = ids

export default VueOptions.vue settings
